import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=46a0267b&scoped=true"
import script from "./gift.vue?vue&type=script&lang=js"
export * from "./gift.vue?vue&type=script&lang=js"
import style0 from "./gift.vue?vue&type=style&index=0&id=46a0267b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0267b",
  null
  
)

export default component.exports